import _typeof from "@babel/runtime/helpers/typeof";
/**
 * Returns merged objects
 * @param {...object} sources array of objects
 * @returns {object} merged object
 */
export var merge = function merge() {
  for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
    sources[_key] = arguments[_key];
  }
  return sources.reduce(function (acc, current) {
    // loop through current's keys
    Object.keys(current).forEach(function (k) {
      var accVal = acc[k];
      var curVal = current[k];
      if (curVal !== null && _typeof(curVal) === 'object' && accVal !== null && _typeof(accVal) === 'object' && !Array.isArray(curVal) && !Array.isArray(accVal)) {
        acc[k] = merge(accVal, curVal);
      } else {
        acc[k] = curVal;
      }
    });
    return acc;
  }, {});
};

/**
 * gets method using optional chaining
 * @param {object | null | undefined} object object being accessed
 * @param {string} path the path used to access this object
 * @param {unknown} valueIfNull value that gets returned when this get operation returns null
 * @returns {typeof object | typeof valueIfNull} value of the object at the path or the valueIfNull
 */
export var getValue = function getValue(object, path) {
  var valueIfNull = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  if (JSON.stringify(object) === '{}') return valueIfNull;
  var value = path.split('.').reduce(function (o, k) {
    return (o || {})[k];
  }, object);
  return value ? value : valueIfNull;
};

/**
 * creates a map from a list of strings
 * @param {string[]} list
 * @returns {object} created map object
 */
export var createMap = function createMap(list) {
  return list.reduce(function (a, c) {
    if (c !== '') {
      a[c] = c;
    }
    return a;
  }, {});
};

/**
 * determines if an object is empty or not
 * @param {object} obj
 * @returns {boolean} true if object is empty, false otherwise
 */
export var isEmpty = function isEmpty(obj) {
  return Object.keys(obj).length === 0;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/ObjectUtils.js
// module id = 3498
// module chunks = 11